import { __assign, __read } from "tslib";
/* eslint-disable @typescript-eslint/prefer-optional-chain */
import { isObject } from '@slardar/sdk-template';
import { getDefaultBrowser, getDefaultDocument } from './defaults';
export function onPageLoad(callback) {
    var window = getDefaultBrowser();
    var document = getDefaultDocument();
    if (!window || !document)
        return;
    if (document.readyState === 'complete') {
        callback();
        return;
    }
    window.addEventListener('load', function () {
        setTimeout(function () {
            callback();
        }, 0);
    }, false);
}
export function onDOMContentLoaded(callback) {
    var window = getDefaultBrowser();
    var document = getDefaultDocument();
    if (!window || !document)
        return;
    if (document.readyState === 'loading') {
        window.addEventListener('DOMContentLoaded', function () {
            setTimeout(function () {
                callback();
            }, 0);
        }, false);
        return;
    }
    callback();
}
export var invokeCallbackOnce = function (cb) {
    var hasInvoked = false;
    var invoke = function (params) {
        if (hasInvoked)
            return;
        hasInvoked = true;
        cb && cb(params);
    };
    return [invoke];
};
export var onPageUnload = function (cb) {
    var window = getDefaultBrowser();
    if (!window)
        return;
    var _a = __read(invokeCallbackOnce(cb), 1), invokeCbOnce = _a[0];
    ['unload', 'beforeunload', 'pagehide'].forEach(function (ev) {
        window.addEventListener(ev, invokeCbOnce);
    });
};
export var onceHidden = function (cb, once) {
    if (once === void 0) { once = true; }
    var document = getDefaultDocument();
    var window = getDefaultBrowser();
    if (!document || !window)
        return;
    if (document.visibilityState === 'hidden') {
        cb();
        return;
    }
    var onVisibilityChange = function () {
        if (document.visibilityState === 'hidden') {
            cb();
            once && removeEventListener('visibilitychange', onVisibilityChange, true);
        }
    };
    window.addEventListener('visibilitychange', onVisibilityChange, true);
};
export var loadScript = function (url, callback) {
    var _a;
    /* istanbul ignore next */
    var document = getDefaultDocument();
    // untestable for now
    /* istanbul ignore next */
    if (document) {
        var script = document.createElement('script');
        script.src = url;
        script.crossOrigin = 'anonymous';
        script.onload = callback;
        (_a = document.head) === null || _a === void 0 ? void 0 : _a.appendChild(script);
    }
};
export var getConfig = function (c, defaultConfig) {
    if (isObject(c)) {
        return __assign(__assign({}, defaultConfig), c);
    }
    else {
        return c ? defaultConfig : false;
    }
};
//# sourceMappingURL=misc.js.map